import { render, staticRenderFns } from "./editable_item_name.vue?vue&type=template&id=0b4c90aa&scoped=true&"
import script from "./editable_item_name.vue?vue&type=script&lang=js&"
export * from "./editable_item_name.vue?vue&type=script&lang=js&"
import style0 from "./editable_item_name.vue?vue&type=style&index=0&id=0b4c90aa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4c90aa",
  null
  
)

export default component.exports